import * as TabsPrimitive from "@radix-ui/react-tabs";
import classes from "./Tabs.module.scss";
import { clsx } from "clsx";
import { TabsContentProps } from "./TabsContentProps";

export function TabsContent(props: TabsContentProps) {
  const { children, className, ...rest } = props;

  return (
    <TabsPrimitive.Content
      className={clsx(classes.content, className)}
      {...rest}
    >
      {children}
    </TabsPrimitive.Content>
  );
}
